import React, { useEffect } from 'react';
import './Nav.css';

export function Nav() {
    const modoGuardado = localStorage.getItem('modo');

    const toggleLightTheme = () => {
        const body = document.body;
        body.classList.add('light-theme');
        body.classList.remove('dark-theme');
        localStorage.setItem('modo', 'light-theme');
    };

    const toggleDarkTheme = () => {
        const body = document.body;
        body.classList.remove('light-theme');
        body.classList.add('dark-theme');
        localStorage.setItem('modo', 'dark-theme');
    };

    useEffect(() => {
        const body = document.body;
        if (modoGuardado === 'light-theme') {
            body.classList.add('light-theme');
            body.classList.remove('dark-theme');
        } else if (modoGuardado === 'dark-theme') {
            body.classList.remove('light-theme');
            body.classList.add('dark-theme');
        }
    }, [modoGuardado]);

    return (
        <form className="nav">
            <button
                onClick={toggleLightTheme}
                type="button"
                className={`nav_button ${modoGuardado === 'light-theme' ? 'active' : ''}`}
            >
                Light
            </button>

            <button
                onClick={toggleDarkTheme}
                type="button"
                className={`nav_button ${modoGuardado === 'dark-theme' ? 'active' : ''}`}
            >
                Dark
            </button>
        </form>
    );
}
